import { render, staticRenderFns } from "./SysMail.vue?vue&type=template&id=6f5e0d23&scoped=true&"
import script from "./SysMail.vue?vue&type=script&lang=js&"
export * from "./SysMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e0d23",
  null
  
)

export default component.exports